import { Component, Input, OnInit } from '@angular/core';
import { UserPreferences, UserPreferencesService } from '../../../../services/storage/user_preferences.service';

@Component({
  selector: 'dashboard-project-deviations',
  templateUrl: './project-deviations.component.html',
  styleUrls: ['./project-deviations.component.scss']
})
export class DashboardProjectDeviationsComponent implements OnInit {
  @Input() plantId: number = -1;
  @Input() deviations: any[] = [];

  userPreferences: UserPreferences = this.UserPreferencesService.getDefault();

  constructor(private UserPreferencesService: UserPreferencesService) { }

  ngOnInit(): void {
    this.UserPreferencesService.get().subscribe(
      (settings: UserPreferences) => this.userPreferences = settings,
      (error: any) => console.error(error)
    );
  }
  showDeviations() {
  }
}
